import React, { useContext } from 'react';

// Hooks
import { useMarketingUrl } from 'Shared/utils/hooks/use-marketing-url';

// Constants
import ExternalLinkConstants from 'Shared/constants/ExternalLinks.constants';

// Context
import MobileContext from 'Shared/contexts/MobileContext';

// Components
import { WpPageLayout, WpPageBody } from 'Wpds/components/page-layout';
import { WpCard, WpCardBody } from 'Wpds/components/card';
import { WpIllustration, Illustrations } from 'Wpds/components/illustration';

// Styles
import './LoggedOutWrapper.scss';

type Props = {
  children: React.ReactNode;
};

const LoggedOutWrapper = ({ children }: Props) => {
  const isMobile = useContext(MobileContext);
  const { PISoftwareMarketingUrl, PIMarketingUrl } = useMarketingUrl();

  const year = new Date().getFullYear();
  const baseClassName = 'LoggedOutWrapper';
  return (
    <WpPageLayout className={baseClassName}>
      <WpPageBody>
        <div className={`${baseClassName}__header`}>
          <a href={PISoftwareMarketingUrl} rel="noopener noreferrer" target="_blank">
            <WpIllustration
              src={Illustrations.pi_logo_full_red_with_text}
              className={`${baseClassName}__header__logo`}
              alt="Predictive Index Logo"
            />
          </a>
        </div>
        <WpCard className={`${baseClassName}__card`}>
          <WpCardBody padding={isMobile ? 16 : 32}>{children}</WpCardBody>
        </WpCard>
      </WpPageBody>
      <div className={`${baseClassName}__footer`}>
        <span>
          ©{year}&nbsp;
          <a
            href={PIMarketingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={`${baseClassName}__footer__link`}
          >
            The Predictive Index
          </a>
        </span>
        <span className={`${baseClassName}__footer__links`}>
          <a
            href={ExternalLinkConstants.terms_of_service}
            target="_blank"
            rel="noopener noreferrer"
            className={`${baseClassName}__footer__link ${baseClassName}__footer__links__link`}
          >
            Terms of Service
          </a>
          <a
            href={ExternalLinkConstants.privacy_policy}
            target="_blank"
            rel="noopener noreferrer"
            className={`${baseClassName}__footer__link ${baseClassName}__footer__links__link`}
          >
            Privacy
          </a>
          <a
            href={ExternalLinkConstants.contact_us}
            target="_blank"
            rel="noopener noreferrer"
            className={`${baseClassName}__footer__link ${baseClassName}__footer__links__link`}
          >
            Contact Support
          </a>
        </span>
      </div>
    </WpPageLayout>
  );
};

export default LoggedOutWrapper;
